export const ImpactType = { Wind: "wind", SolarFarm: "solarfarm", SolarRooftop: "solarrooftop", Biomass: "biomass" };